import angular from 'angular';
import { Registration } from '../../registrations/model/registration';
import { guid1 } from '@/shared/utils/guid';
import moment from 'moment';
import { getFirstSelectedInvoiceStreamId } from '@/shared/components/registration/registrationHelpers';

angular.module('cxRelations').directive('cxPlannedRegistrations', function() {
  return {
    restrict: 'E',
    template: require('./plannedRegistrations.html'),
    scope: {
      relation: '=',
    },
    controllerAs: 'vm',
    bindToController: true,
    controller: [
      'resourceFactorySvc',
      'flySvc',
      'userData',
      'ModalService',
      'dialogsSvc',
      'resourceNameFilter',
      '$translate',
      'dataCache',
      function(
        resourceFactorySvc,
        flySvc,
        userData,
        ModalService,
        dialogsSvc,
        resourceNameFilter,
        $translate,
        dataCache,
      ) {
        var vm = this;
        var resource = resourceFactorySvc.get('plannedRegistration');
        var showError = function(error) {
          flySvc.error(error.data.code, error.data.parameters);
          return '';
        };

        var mapPlanning = function(item) {
          if (item.template && !(item.template instanceof Registration)) {
            item.template = new Registration(item.template);
            item.template.setResourceName(resourceNameFilter);
          }
          if (item.invoiceStreamId) {
            item.invoiceStream = vm.relation.invoiceStreams.find(
              x => x.id === item.invoiceStreamId,
            );
          }
          if (item.template) {
            if (item.template.userId === guid1) {
              item.template.userName = $translate.instant('SystemUser');
            } else {
              item.template.userName = vm.users.find(x => x.id === item.template.userId)?.text;
            }
          }
          return item;
        };

        vm.$onInit = function() {
          vm.hasInactive = false;
          vm.showInactive = !userData.get('HideInactivePlannedRegistrations', false);
          vm.schedules = null;
          vm.users = dataCache
            .getArray('user')
            .filter(x => x.isActive || !x.hidden)
            .map(({ userID, firstName, lastName, isActive }) => ({
              id: userID,
              name: `${firstName} ${lastName}`,
              text: (isActive ? '' : '⚠ ') + `${firstName} ${lastName}`,
              isActive,
            }));

          vm.loading = true;
          resource.query(
            {
              id: vm.relation.id,
            },
            function(data) {
              vm.list = data.map(mapPlanning);
              vm.hasInactive = vm.list.some(
                x => !!x.endDate && moment.utc(x.endDate).isBefore(moment.utc(), 'day'),
              );
              vm.loading = false;
            },
            showError,
          );
        };

        vm.loadSchedules = function() {
          if (vm.schedules != null) return null;
          return resource.schedules(
            {},
            function(data) {
              vm.schedules = data;
            },
            showError,
          ).$promise;
        };

        vm.editRegTemplate = function(planning) {
          ModalService.showModal({
            template: require('../dialogs/plannedRegistrationDialog.html'),
            controller: 'PlannedRegistrationDialogCtrl',
            controllerAs: 'vm',
            locationChangeSuccess: false,
            inputs: {
              invoiceStreamId: planning.invoiceStreamId,
              invoiceStreams: vm.relation.invoiceStreams,
              relationId: vm.relation.id,
              plannedReg: angular.copy(planning),
              crmType: vm.relation.crm,
            },
          }).then(function(modal) {
            modal.element.modal();
            modal.element.on('hidden.bs.modal', function(e) {
              modal.element.off(e); //Remove event
              modal.element.remove(); //Remove element
            });
            modal.close.then(function(result) {
              if (!result) return;

              angular.extend(planning, mapPlanning(result));

              flySvc.success('msgConfirmChange');
            });
          });
        };

        vm.save = function(planning, field, data) {
          //Validation error
          if (typeof data === 'undefined') return '';
          if (field === 'startDate' && !data) return '';

          if (angular.equals(planning[field], data)) return false;
          var model = angular.copy(planning);
          model[field] = data;
          delete model.template;
          return resource.update(model).$promise.then(function(response) {
            if (!response) return false;

            angular.extend(planning, mapPlanning(response));

            flySvc.success('msgConfirmChange');
            return false;
          }, showError);
        };

        vm.delete = function(planning) {
          if (!planning || !planning.id) return;

          dialogsSvc
            .showYesNo('msgConfirmDeleteTitle', 'msgDeletePlannedRegistration')
            .then(function() {
              resource.delete(
                {
                  id: planning.id,
                },
                function() {
                  var idx = vm.list.indexOf(planning);
                  if (idx >= 0) vm.list.splice(idx, 1);

                  flySvc.success('msgRegistrationRemoved');
                },
                showError,
              );
            });
        };

        vm.addPlannedRegistration = function() {
          ModalService.showModal({
            template: require('../dialogs/plannedRegistrationDialog.html'),
            controller: 'PlannedRegistrationDialogCtrl',
            controllerAs: 'vm',
            locationChangeSuccess: false,
            inputs: {
              invoiceStreamId: getFirstSelectedInvoiceStreamId(vm.relation),
              relationId: vm.relation.id,
              invoiceStreams: vm.relation.invoiceStreams,
              plannedReg: null,
              crmType: vm.relation.crm,
            },
          }).then(function(modal) {
            modal.element.modal();
            modal.element.on('hidden.bs.modal', function(e) {
              modal.element.off(e); //Remove event
              modal.element.remove(); //Remove element
            });
            modal.close.then(function(result) {
              if (result) {
                vm.list.push(mapPlanning(result));
                flySvc.success('msgConfirmChange');
              }
            });
          });
        };

        vm.showPlannedSchedules = function(plannedRegistration) {
          ModalService.showModal({
            template: require('../dialogs/plannedRegistrationScheduleDialog.html'),
            controller: 'PlannedregistrationScheduleDialogCtrl',
            controllerAs: 'vm',
            locationChangeSuccess: false,
            inputs: {
              plannedRegistration: plannedRegistration,
            },
          }).then(function(modal) {
            modal.element.modal();
            modal.element.on('hidden.bs.modal', function(e) {
              modal.element.off(e); //Remove event
              modal.element.remove(); //Remove element
            });
          });
        };
        vm.showInactiveChanged = function() {
          userData.set('HideInactivePlannedRegistrations', !vm.showInactive);
        };
        vm.filterInactive = function(plannedRegistration) {
          if (!vm.hasInactive) return true;
          if (!!vm.showInactive) return true;
          if (!plannedRegistration.endDate) return true;
          return moment.utc(plannedRegistration.endDate).isSameOrAfter(moment.utc(), 'day');
        };
      },
    ],
  };
});
